import notificationReducer from '@features/components/Notification/notificationSlice.ts';
import globalConfirmPromptReducer from '@features/components/Prompt/globalConfirmPromptSlice.ts';
import questionReducer from '@features/Question/questionSlice.ts';
import { type Action, configureStore, type ThunkAction } from '@reduxjs/toolkit';

import { entrySplitApi } from './entryApi.ts';
import appReducer from './reducers/appSlice.ts';
import authReducer from './reducers/authSlice.ts';

export const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    [entrySplitApi.reducerPath]: entrySplitApi.reducer,
    auth: authReducer,
    app: appReducer,
    globalConfirmPrompt: globalConfirmPromptReducer,
    notification: notificationReducer,
    question: questionReducer,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(entrySplitApi.middleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
